<script>
import BoardTable from '@components/board/BoardTable'
import BoardView from '@components/board/BoardView'
import PaginateFetch from '@mixins/PaginateFetch'
import TableSearch from '@components/board/TableSearch'

export default {
  mixins: [PaginateFetch],
  components: { BoardTable, BoardView, TableSearch },
  data() {
    return {
      paginationOptions: {
        dataColumns: [],
        tableBreakpoint: 'sm',
        columns: {
          xl: 3,
          lg: 2,
          xs: 1,
        },
      },
    }
  },
  computed: {
    dataColumns() {
      const dataColumns = this.paginationOptions.dataColumns
        .map(({ size, ...column }) => ({ ...column, size: size ?? 1 }))

      const proportionTotal = dataColumns
        .reduce((total, { size }) => total + size, 0)

      return dataColumns
        .map(column => ({
          ...column,
          style: {
            width: `${(100 / proportionTotal) * column.size}%`,
          },
        }))
    },
    pagination() {
      if (this.paginationStored) return this.paginationStored

      return {
        ...this.paginationOptions,
        dataColumns: this.dataColumns,
      }
    },
  },
  render() {
    return ''
  },
}
</script>
